
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";

export default Vue.extend({
  data() {
    return {
      overtime: false,
      timeout: null
    };
  },
  mounted() {
    msDataProvider.watchData(
        "localAppConnected",
        async (value) => {
          if (value) {
            await this.$router.push("/prepare").catch((e) => {
              console.log(e);
            });
          }
        },
        this
    );
    const self = this;
    this.timeout = setTimeout(async () => {
      await this.checkLocalAppConnect()
      self.overtime = true;
    }, 30000);
  },
  methods: {
    reload() {
      window.location.reload();
    },
    async checkLocalAppConnect() {
      try {
        const localAppConnected = await msDataProvider.getData("localAppConnected")
        if (localAppConnected) {
          this.$router.push("/prepare").catch((e) => e);
        } else {
          this.timeout = setTimeout(() => {
            this.checkLocalAppConnect();
          }, 5000)
        }
      } catch (e) {
        this.reload();
      }
    }
  },
  destroyed() {
    msDataProvider.unregisterView(this);
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
});
